import React, { useEffect } from 'react';
import { Route } from 'react-router';

import { entityReset } from '@uncinc/react-drupal-core';

import useTypedDispatch from '../../../hooks/useTypedDispatch';
import type { CustomRouteProps } from '../types';

const CustomRoute: React.FC<CustomRouteProps> = (props) => {
  const dispatch = useTypedDispatch();

  // We may have done a request to translate-path for the current route.
  // Reset the entity to prevent a possible 404 page flash.
  useEffect(() => () => {
    dispatch(entityReset());
  });

  return (
    <Route {...props} />
  );
};

export default CustomRoute;
